export default "__VITE_ASSET__CUOP2wY1__"